import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export default function Property({
    label,
    value,
    vertical
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: (typeof value == 'object' || !!vertical) ? 'column' : 'row',
                gap: 1,
                py: 0.5,
            }}
        >
            <Typography
                color='textPrimary'
                sx={{
                    flexShrink: 0,
                    maxWidth: 140,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
            >
                {label}
            </Typography>

            {typeof value == 'object'
                ? value
                : (
                    <Typography
                        color='textSecondary'
                        sx={{
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {
                            ((typeof value == 'string' && value.trim() == '') || value == null)
                            ? '━'
                            : value
                        }
                    </Typography>
                )
            }
        </Box>
    )
}